/* eslint-disable no-useless-escape */
/* eslint-disable react/require-default-props */
import React from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

import constants from '../../utils/constants';
import favicon from '../../img/favicon.ico';

function SEO({ plp: { link = '', title = '' } = {}, template = '' }) {
  return (
    <Helmet
      htmlAttributes={{
        lang: 'en-US',
      }}
      title={`${title}  | Grow with Kabbage`}
      meta={[
        ...(template !== 'SbaApply'
          ? [
              {
                name: 'robots',
                content: 'noindex,follow',
              },
            ]
          : []),
        {
          property: `og:locale`,
          content: 'en_US',
        },
        {
          property: `og:type`,
          content: 'article',
        },
        {
          property: `og:title`,
          content: `${title}  | Grow with Kabbage`,
        },
        ...(link
          ? [
              {
                property: `og:url`,
                content: link,
              },
            ]
          : []),
        {
          property: `og:site_name`,
          content: 'Grow With Kabbage',
        },
        {
          property: `article:publisher`,
          content: `https://www.facebook.com/KabbageInc`,
        },
        {
          property: `og:image`,
          content: `https://s3.amazonaws.com/kabbage-media-user/blog/wp-content/uploads/2013/07/09191400/Kabbage-Instagram.png`,
        },
        {
          property: `og:image:secure_url`,
          content: `https://s3.amazonaws.com/kabbage-media-user/blog/wp-content/uploads/2013/07/09191400/Kabbage-Instagram.png`,
        },
        {
          property: `og:image:width`,
          content: `680`,
        },
        {
          property: `og:image:height`,
          content: `680`,
        },
        {
          name: `twitter:card`,
          content: `summary_large_image`,
        },
        {
          name: `twitter:description`,
          content: 'Share',
        },
        {
          name: `twitter:title`,
          content: `${title}  | Grow with Kabbage`,
        },
        {
          name: `twitter:site`,
          content: '@KabbageInc',
        },
        {
          name: `twitter:image`,
          content:
            'https://s3.amazonaws.com/kabbage-media-user/blog/wp-content/uploads/2013/07/09191400/Kabbage-Instagram.png',
        },
        {
          name: `twitter:creator`,
          content: '@KabbageInc',
        },
      ]}
    >
      {template === 'SbaApply' && (
        <link
          rel="canonical"
          href="https://www.kabbage.com/paycheck-protection-program-loans"
        />
      )}
      <link rel="shortcut icon" type="image/ico" href={favicon} as="script" />
      <link
        rel="preload"
        href="//cdn.optimizely.com/js/17445442224.js"
        as="script"
      />
      <link rel="preconnect" href="//logx.optimizely.com" />
      <script src="https://cdn.optimizely.com/js/17445442224.js" />
      <script type="application/ld+json">{`@context":"https:\/\/schema.org","@type":"Organization","url":"https:\/\/www.kabbage.com\/blog\/","sameAs":["https:\/\/www.facebook.com\/KabbageInc","https:\/\/www.instagram.com\/kabbageinc\/","https:\/\/www.linkedin.com\/company\/kabbage-inc","https:\/\/www.youtube.com\/channel\/UCPD_7-MCjZKxtKLyiUlOCyg","https:\/\/twitter.com\/KabbageInc"],"@id":"https:\/\/www.kabbage.com\/blog\/#organization","name":"Grow with Kabbage","logo":"https:\/\/s3.amazonaws.com\/kabbage-media-user\/blog\/wp-content\/uploads\/2013\/07\/09191400\/Kabbage-Instagram.png`}</script>
      {/* Kabbage Tracking Pixel */}
      <script>
        {`
            var wrapperContent = document.getElementById('wrap');
            if (wrapperContent) {
                wrapperContent.innerHTML += '<img style="display:none;" src="//${constants.sites.us}/app/tracking?url=' + escape(window.location) + '&referrer=' + escape(document.referrer) + '" />';
            }
          `}
      </script>
      {/* End Kabbage Tracking Pixel */}
      {/* Google Analytics */}
      <script>
        {`
            (function(a,s,y,n,c,h,i,d,e){s.className+=' '+y;h.start=1*new Date;
                h.end=i=function(){s.className=s.className.replace(RegExp(' ?'+y),'')};
                (a[n]=a[n]||[]).hide=h;setTimeout(function(){i();h.end=null},c);h.timeout=c;
            })(window,document.documentElement,'async-hide','dataLayer',4000,
                {'GTM-NPF27MS':true});

            (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
            m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
            })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
          `}
      </script>
      {/* End Google Analytics */}
    </Helmet>
  );
}

SEO.propTypes = {
  plp: PropTypes.shape({
    link: PropTypes.string,
    title: PropTypes.string,
  }),
  template: PropTypes.string,
};

export default SEO;
